import { Link } from 'react-router-dom';
import sc from 'web/components/styled';
import linkUnstyled from './linkUnstyled.css';

const LinkUnstyled = sc(Link)(linkUnstyled);
LinkUnstyled.displayName = 'LinkUnstyled';

export default LinkUnstyled;
